<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="layout--main" :class="[layoutTypeClass, navbarClasses, footerClasses, {'no-scroll': isAppPage}]">

    <v-nav-menu
      :navMenuItems = "navMenus"
      title         = "FilledU"
      parent        = ".layout--main" />

    <div id="content-area" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]">
      <div id="content-overlay" />

    <!-- Navbar -->
    <template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1200">
      <div style="height: 62px" v-if="navbarType === 'static'"></div>
    </template>

    <template v-else>
      <the-navbar-vertical
        :navbarColor="navbarColor"
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]" />
    </template>
    <!-- /Navbar -->

      <div class="content-wrapper">

        <div class="router-view">
          <div class="router-content">

            <transition :name="routerTransition">
              <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle" class="router-header flex flex-wrap items-center mb-6">
                <div
                  class="content-area__heading"
                  :class="{'pr-4 border-0 md:border-r border-solid border-grey-light' : $route.meta.breadcrumb}">
                  <h2 class="mb-1">{{ routeTitle }}</h2>
                </div>


                <vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb" :route="$route" :isRTL="$vs.rtl" />
              </div>
            </transition>

            <div class="content-area__content">

              <back-to-top bottom="5%" :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'" visibleoffset="500" v-if="!hideScrollToTop">
                <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg btn-back-to-top" />
              </back-to-top>

              <transition :name="routerTransition" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle" @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)" />
              </transition>
            </div>
          </div>
        </div>
      </div>
      <the-footer/>
    </div>
  </div>
</template>


<script>
import BackToTop           from 'vue-backtotop'
import HNavMenu            from "@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue"
// import navMenuItems        from "@/layouts/components/space/vertical-nav-menu/navMenuItems.js"
import TheNavbarHorizontal from '@/layouts/components/navbar/TheNavbarHorizontal.vue'
import TheNavbarVertical   from '@/layouts/components/navbar/TheDashboardNavbarVertical.vue'
import TheFooter           from '@/layouts/components/TheFooter.vue'
import themeConfig         from '@/../themeConfig.js'
import VNavMenu            from '@/layouts/components/space/vertical-nav-menu/VerticalNavMenu.vue'
import moduleInsight from '@/store/insight/moduleInsight.js'
import moduleAttend from '@/store/attend/moduleAttend.js'

export default {
  components: {
    BackToTop,
    HNavMenu,
    TheFooter,
    TheNavbarHorizontal,
    TheNavbarVertical,
    VNavMenu,
  },
  data() {
    return {
      footerType        : themeConfig.footerType  || 'static',
      hideScrollToTop   : themeConfig.hideScrollToTop,
      isNavbarDark      : false,
      navbarColor       : themeConfig.navbarColor || '#fff',
      navbarType        : themeConfig.navbarType  || 'floating',
      navMenus      : [
        {
          url: "/apps/space/dashboard/main/",
          param: "0",
          name: "Home",
          slug: "home",
          icon: "HomeIcon",
        },

        // {
        //   url: "/apps/space/dashboard/notice-board/space/",
        //   name: "QnA",
        //   slug: "notice-board",
        //   icon: "InfoIcon",
        // },
        {
          url: "/apps/space/dashboard/notice/space/",
          name: "공지사항",
          slug: "notice",
          icon: "YoutubeIcon",
        },
        {
          url: "/apps/space/dashboard/submit/space/",
          name: "결과물제출",
          slug: "submit",
          icon: "LayersIcon",
        },
        {
          url: "/apps/space/dashboard/student-notice/space/",
          name: "게시판",
          slug: "student-notice",
          icon: "BookIcon",
        },
        {
          url: "/apps/space/dashboard/online-test/space/",
          name: "온라인테스트",
          slug: "student-notice",
          icon: "Edit3Icon",
        },
        {
          url: "/apps/space/dashboard/attend/space/",
          name: "전자 출석",
          slug: "student-notice",
          icon: "ClipboardIcon",
        },
        {
          url: '/apps/space/dashboard/project/',
          param: "0",
          name: "프로젝트",
          slug: "project",
          icon: "MonitorIcon",
        },
        {
          url: "/apps/space/dashboard/members/",
          param: "0",
          name: "멤버",
          slug: "invite",
          icon: "UsersIcon",
        },
        {
          url: "/apps/space/dashboard/insight/space/",
          name: "인사이트",
          slug: "insight",
          icon: "DatabaseIcon",
        },
        // {
        //   url: "/apps/space/dashboard/attend/space/",
        //   name: "인사이트",
        //   slug: "student-notice",
        //   icon: "ClipboardIcon",
        // }
      ],
      routerTransition  : themeConfig.routerTransition || 'none',
      routeTitle        : this.$route.meta.pageTitle
    }
  },
  watch: {
    "$route"() {
      this.routeTitle = this.$route.meta.pageTitle
    },
    isThemeDark(val) {
      const color = this.navbarColor == "#fff" && val ? "#10163a" : "#fff"
      this.updateNavbarColor(color)
    },
    "$store.state.mainLayoutType"(val) {
      this.setNavMenuVisibility(val)
    }
  },
  computed: {
    bodyOverlay() { return this.$store.state.bodyOverlay },
    contentAreaClass() {
      if(this.mainLayoutType === "vertical") {
        if      (this.verticalNavMenuWidth == "default") return "content-area-reduced"
        else if (this.verticalNavMenuWidth == "reduced") return "content-area-lg"
        else return "content-area-full"
      }
      // else if(this.mainLayoutType === "boxed") return "content-area-reduced"
      else return "content-area-full"
    },
    footerClasses() {
      return {
        'footer-hidden': this.footerType == 'hidden',
        'footer-sticky': this.footerType == 'sticky',
        'footer-static': this.footerType == 'static',
      }
    },
    isAppPage() {
      return this.$route.meta.no_scroll
    },
    isThemeDark()     { return this.$store.state.theme == 'dark' },
    layoutTypeClass() { return `main-${this.mainLayoutType}` },
    mainLayoutType()  { return this.$store.state.mainLayoutType  },
    navbarClasses()   {
      return {
        'navbar-hidden'   : this.navbarType == 'hidden',
        'navbar-sticky'   : this.navbarType == 'sticky',
        'navbar-static'   : this.navbarType == 'static',
        'navbar-floating' : this.navbarType == 'floating',
      }
    },
    verticalNavMenuWidth() { return this.$store.state.verticalNavMenuWidth },
    windowWidth()          { return this.$store.state.windowWidth },
    serviceWorkspaces()    { return this.$store.state.space.serviceWorkspaces },
    activeSpaceInfo()      { return this.$store.state.space.ActiveSpaceInfo },
    activeUserLevel()      { return this.$store.state.space.ActiveDashBoardLevel },
    workspaceMembers()     { return this.$store.state.space.workspaceMembers },
    insightVector()        { return this.$store.state.insight.insightVector },
    activeUserInfo()       { return this.$store.state.AppActiveUser },
  },
  methods: {
    changeRouteTitle(title) {
      this.routeTitle = title
    },
    updateNavbarColor(val) {
      this.navbarColor = val
      if (val == "#fff") this.isNavbarDark = false
      else this.isNavbarDark = true
    },
    setNavMenuVisibility(layoutType) {
      if((layoutType === 'horizontal' && this.windowWidth >= 1200) || (layoutType === "vertical" && this.windowWidth < 1200)) {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
        this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')
      }
      else {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
      }
    },
    register(){
      if(!moduleInsight.isRegistered) {
        this.$store.registerModule('insight', moduleInsight)
        moduleInsight.isRegistered = true
      }
      if(!moduleAttend.isRegistered) {
        this.$store.registerModule('attend', moduleAttend)
        moduleAttend.isRegistered = true
      }
    },
    setInsight(){
      if(this.activeUserLevel >= 3){
          for(var index in this.workspaceMembers){
            if(this.workspaceMembers[index].level < 3){
              this.$store.commit("insight/SET_INSIGHT_VECTOR", {user_id:this.workspaceMembers[index].user_id, name:this.workspaceMembers[index].name, email:this.workspaceMembers[index].email, miss_count:this.workspaceMembers[index].miss_count,
              late_count:this.workspaceMembers[index].late_count, total_count:this.workspaceMembers[index].total_count, attend_count:this.workspaceMembers[index].attend_count, submit:[], test:[]})
            }
          }
      }else {
        if(this.workspaceMembers && this.insightVector.length == 0){
          for(var k in this.workspaceMembers){
            if(this.activeUserInfo.uid == this.workspaceMembers[k].user_id){
              this.$store.commit("insight/SET_INSIGHT_VECTOR", {user_id:this.workspaceMembers[k].user_id, name:this.workspaceMembers[k].name, email:this.workspaceMembers[k].email, miss_count:this.workspaceMembers[k].miss_count,
              late_count:this.workspaceMembers[k].late_count, total_count:this.workspaceMembers[k].total_count, attend_count:this.workspaceMembers[k].attend_count, submit:[], test:[]})
              break
            }
          }
        }
      }
    }
  },
  beforeDestroy() {
    this.$store.commit('insight/UNREGISTER')
    this.$store.unregisterModule('insight')
    moduleInsight.isRegistered = false

    this.$store.unregisterModule('attend')
    moduleAttend.isRegistered = false
  },
  beforeCreate() {
    if (!localStorage.getItem("filleduToken") && !sessionStorage.getItem("filleduToken")) {
      this.$router.push('/pages/login')
    }
  },
  created() {
    this.register()
    if(this.$route.params.spaceId == 0){
      this.$route.params.spaceId = this.activeSpaceInfo.id
    }
    if(this.$store.state.space.ActiveSpaceInfo.id != this.$route.params.spaceId){
      if(this.$route.params.spaceId == '0'){
        this.$vs.dialog({
            color: 'danger',
            title: `error`,
            text: 'Workspace 주소가 정확한지 확인해 주세요',
            accept: this.acceptAlert
          })
        return
      }
      this.$store.dispatch('space/getAllWorkspace')
      this.$store.dispatch('space/getMembers', {'id' : this.$route.params.spaceId}).then(()=>{
        this.$store.commit('space/SET_ACTIVE_USER_LEVEL', this.$store.state.AppActiveUser.uid)
        if(this.activeUserLevel == 0){
          this.$router.push('/pages/accept/id='+this.activeWorkspace.id+'&title='+this.activeWorkspace.title+'&category=[Workspace]')
        }
        this.setInsight()
        this.$store.dispatch('notice/getNotice', this.activeSpaceInfo.id)
        this.$store.dispatch('project/getProject', this.activeSpaceInfo.id)
        this.$store.commit('space/SET_SHARE_CLASS', this.activeSpaceInfo.id)
      })
    } else{
      this.$store.dispatch('space/getMembers', {'id' : this.activeSpaceInfo.id}).then(()=>{
        this.$store.commit('space/SET_ACTIVE_USER_LEVEL', this.$store.state.AppActiveUser.uid)
        this.setInsight()
      })
      this.$store.dispatch('notice/getNotice', this.activeSpaceInfo.id)
      this.$store.dispatch('project/getProject', this.activeSpaceInfo.id)
      this.$store.commit('space/SET_SHARE_CLASS', this.activeSpaceInfo.id)
    }
    for (var item in this.navMenus){
      this.navMenus[item].url =  this.navMenus[item].url+this.$route.params.spaceId
    }
    const color = this.navbarColor == "#fff" && this.isThemeDark ? "#10163a" : this.navbarColor
    this.updateNavbarColor(color)
    this.setNavMenuVisibility(this.$store.state.mainLayoutType)
  }
}

</script>
